import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/Results/ResultsView/index.js";
const variants = import.meta.webpackContext("/components/Results/ResultsView", { recursive: true, regExp: /\.\/__variants__\/plp\-mweb\-image\-gallery\/v3\/index\.js/ });
export default pointCut({ joinPoint, variants });